import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=13ad7f72&"
import script from "./Novidades.vue?vue&type=script&lang=js&"
export * from "./Novidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports